<template>
  <div v-if="open" class="resource-crash-banner" role="status">
    <div class="resource-crash-text">
      <p class="resource-crash-copy">This account last restarted {{ when }} because it ran out of server resources. It has restarted {{ times }} from resource limits.</p>
      <p class="resource-crash-upgrade">Upgrade to a higher tier account to get more server resources.</p>
      <p v-if="dismissError" class="resource-crash-error">{{ dismissError }}</p>
    </div>
    <div class="resource-crash-actions">
      <router-link v-if="$route.path !== '/statistics'" to="/statistics" class="resource-crash-link">view log</router-link>
      <button type="button" class="resource-crash-dismiss" :disabled="dismissing" @click="dismiss">{{ dismissing ? 'dismissing…' : 'dismiss' }}</button>
    </div>
  </div>
</template>

<script>

  import axios from 'axios'

  export default {
    data () {

      return {
        at: ``,
        count: 0,
        open: false,
        dismissing: false,
        dismissError: ``
      }
    },
    computed: {
      when () {

        return formatCrashTime(this.at)
      },
      times () {

        return this.count === 1 ? `1 time` : `${this.count} times`
      }
    },
    mounted () {

      this.load()
    },
    methods: {
      async load () {

        try {

          const response = await axios.get(`${VUE_APP_APP_SERVER_URL}/account`, { withCredentials: true })

          this.apply(response.data)
        } catch (error) {

          this.open = false
        }
      },
      apply (data) {

        const count = Number(data && data.resourceCrashCount)

        this.count = Number.isFinite(count) && count > 0 ? count : 0
        this.at = (data && data.resourceCrashAt) || ``
        this.open = noticeOpen(data)
      },
      async dismiss () {

        this.dismissError = ``
        this.dismissing = true

        try {

          const response = await axios.post(`${VUE_APP_APP_SERVER_URL}/account/resource-notice/dismiss`, {}, { withCredentials: true })

          this.apply(response.data)
        } catch (error) {

          this.dismissError = `could not dismiss the notice`
        } finally {

          this.dismissing = false
        }
      }
    }
  }

  function noticeOpen (data) {

    const count = Number(data && data.resourceCrashCount)
    const safe = Number.isFinite(count) && count > 0 ? count : 0

    if (!safe) return false
    if (data && typeof data.resourceCrashNotice === `boolean`) return data.resourceCrashNotice

    return true
  }

  function formatCrashTime (value) {

    const date = new Date(value)

    if (Number.isNaN(date.getTime())) return value || `unknown time`

    return date.toLocaleString(undefined, { dateStyle: `medium`, timeStyle: `short` })
  }

</script>

<style scoped>
.resource-crash-banner {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin: 0 0 16px;
  padding: 12px 16px;
  background-color: #2a2416;
  border: 1px solid #6b5420;
  border-radius: 8px;
}

.resource-crash-text {
  min-width: 0;
}

.resource-crash-copy {
  margin: 0;
  color: #f0e2b6;
  font-size: 0.82rem;
  line-height: 1.45;
}

.resource-crash-upgrade {
  margin: 6px 0 0;
  color: #9ad12b;
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1.45;
}

.resource-crash-error {
  margin: 6px 0 0;
  color: #e05252;
  font-size: 0.78rem;
}

.resource-crash-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.resource-crash-link,
.resource-crash-dismiss {
  background: transparent;
  border: 0;
  color: #9ad12b;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0;
  text-decoration: none;
}

.resource-crash-link:hover,
.resource-crash-dismiss:hover:not(:disabled) {
  color: #b8f046;
}

.resource-crash-dismiss:disabled {
  opacity: 0.45;
  cursor: default;
}
</style>
